<template>
  <div :class="['wrap', osClass]">
    <iframe 
      ref="iframe" 
      :src="htmlSrc" 
      width="100%" 
      height="100%" 
      frameborder="0">
    </iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {
      htmlSrc:'static/feedback.html', // 注意: 直接写 static ,前面不需要加任何路径和字符。
    };
  },
  computed: {
    isIOS() {
      return /iPad|iPhone|iPod/.test(navigator.userAgent);
    },
    isAndroid() {
      return /Android/.test(navigator.userAgent);
    },
    osClass() {
      if (this.isIOS) {
        return 'ios';
      } else if (this.isAndroid) {
        return 'android';
      }
      return '';
    }
  },
  methods: {
    adjustIframeHeight() {
      if (this.isIOS) {
        // 进一步调整header高度值，降低到更合适的值
        const headerHeight = 20; // 进一步降低高度值
        
        // 动态设置容器高度
        const iframeRef = this.$refs.iframe;
        if (iframeRef && iframeRef.parentElement) {
          const container = iframeRef.parentElement;
          // 使用window.innerHeight并减去header高度，确保内容不被header遮挡
          container.style.height = `${window.innerHeight - headerHeight}px`;
        }
      }
    }
  },
  mounted() {
    console.log('Is iOS:', this.isIOS);
    console.log('Is Android:', this.isAndroid);
    
    // 在iOS上调整iframe高度
    if (this.isIOS) {
      this.adjustIframeHeight();
      
      // 监听窗口大小变化
      window.addEventListener('resize', this.adjustIframeHeight);
      
      // 延迟再次调整，确保DOM完全加载
      setTimeout(this.adjustIframeHeight, 500);
    }
  },
  beforeDestroy() {
    if (this.isIOS) {
      window.removeEventListener('resize', this.adjustIframeHeight);
    }
  }
};
</script>

<!-- <style scoped>
.wrap{
  width: 100%;
  height: 1900px;
}
@media screen and (max-width: 768px) {
  .wrap{
    /* height: 1300px; */
  }
  .wrap.ios {
    height: calc(100vh - 5vh);
  }
  .wrap.android {
    height: calc(100vh - 10px);
  }
}
</style> -->

<style scoped>
.wrap{
  width: 100%;
  height: 1900px;
}
@media screen and (max-width: 768px) {
  .wrap{
    /* height: 1300px; */
  }
  .wrap.ios {
    height: calc(100vh - 20px); /* 进一步调整到更低的值 */
    overflow: hidden;
  }
  .wrap.android {
    height: calc(100vh - 10px);
  }
}

/* 特别为iOS设备优化iframe */
.wrap.ios iframe {
  height: 100%;
  -webkit-overflow-scrolling: touch; /* 启用原生滚动 */
  overflow: auto;
}
</style>